module.exports = "/_next/static/resources/photo-3-dbdb8741a37bf2f6e45a4fc77080ea6a.jpg";